import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { and } from '@adornis/validation/functions/and.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { min } from '@adornis/validation/functions/range.js';
import type { LogistikProductCategory } from './enums/LogistikEnums.js';
import { ChancenBriefVariableValue } from './LogistikOrder.js';
import { LogistikProduct } from './LogistikProduct.js';

/**
 * @entity LogistikCart
 */
@Entity()
export class LogistikCart extends AdornisEntity {
  public static override _class = 'HubCart'; // TODO needs migration before we can change this

  @Field(() => [LogistikCartItem], { default: v => v ?? [] })
  public items!: LogistikCartItem[];

  @Field(() => Int)
  public studentCount?: number;
}

/**
 * @entity LogistikCartItem
 */
@Entity()
export class LogistikCartItem extends AdornisEntity {
  public static override _class = 'HubCartItem'; // TODO needs migration before we can change this

  @Field(() => ID, { default: v => v ?? A.getGloballyUniqueID() })
  public _id!: string;

  @Field(() => String)
  public productID!: string;

  @DataLoadedField(() => LogistikProduct, ({ productID }) => productID)
  public product!: LogistikProduct;

  @Field(() => String)
  public productCategory!: LogistikProductCategory;

  @Field(() => Int)
  public quantity!: number;

  @Field(() => [ChancenBriefVariableValue], { default: v => v ?? [] })
  flyaVariableValues: Maybe<ChancenBriefVariableValue[]>;
}

@Entity()
export class LogistikLearningMaterialCartItem extends LogistikCartItem {
  static override _class = 'LogistikLearningMaterialCartItem';

  @Field(() => Boolean)
  public isDigital!: boolean;
}

@Entity()
export class LogistikChancenBriefCartItem extends LogistikCartItem {
  static override _class = 'LogistikChancenBriefCartItem';
  @Field(() => Boolean, { default: v => v ?? false })
  public isSelfPrint!: boolean;
}

export class LogistikWorkshoppackCartiItem extends LogistikCartItem {
  static override _class = 'LogistikWorkshoppackCartiItem';

  @validate(
    and(
      nonOptional({ translationKey: 'Bitte wählen Sie die Anzahl der Trainer:innen' }),
      min(1, 'Mindest Anzahl der Trainer:innen wurde nicht erreicht'),
    ),
  )
  @Field(() => Int)
  public trainersQuantity!: number;

  @validate(
    and(
      nonOptional({ translationKey: 'Bitte wählen Sie die Anzahl die Teilnehmenden' }),
      min(1, 'Mindest Anzahl der Teilnehmenden wurde nicht erreicht'),
    ),
  )
  @Field(() => Int)
  public participantsQuantity!: number;
}
